import { supabase } from "../supabaseClient";
import { createTtlCache } from "./ttlCache";


const cache = createTtlCache(60_000);


/**
 * Parceiros — a faixa discreta no fim da página de Destaques. Só isso.
 * O conteúdo próprio da Mixórdia vive em `highlights`, tabela separada;
 * ver highlightsService.js.
 *
 * A página usa nome, logo e um link — nada além. Por isso o select é
 * explícito: coluna que ninguém renderiza não precisa trafegar.
 */
export const listPartners = async ({ force = false } = {}) => {
  if (!supabase) throw new Error("Supabase client not configured");

  if (!force) {
    const cached = cache.read();
    if (cached) return cached;
  }

  const { data, error } = await supabase
    .from("partners")
    .select("id, name, slug, logo_url, website_url, instagram_url")
    .eq("active", true)
    .order("sort_order", { ascending: true });

  if (error) throw error;

  const result = data || [];
  cache.write(result);

  return result;
};
